import React, { useState, useEffect } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { getCouponsBasedOnDomainAction } from "../../../Store/CouponBaseOnDomain/actions";

import { getCouponByIdAction } from "../../../Store/Coupons/actions";
import "../../../Assets/Scss/Home3recommended.scss";
import { getImageUrlhttps } from "../../../Utils/index";
import PlaceHolderImage from "../../../Assets/Images/PlaceholderImage.png";

import { getCouponUrlAction } from "../../../Store/couponUrl/actions";

function Deals({ match }) {
  const dispatch = useDispatch();

  const { couponbaseondomainList } = useSelector(
    (store) => store.CouponBasedOnDomain
  );
  const { link } = useSelector((state) => state.CouponUrl);

  const [redirect, setRedirect] = useState(false);
  const [redirect2, setRedirect2] = useState(false);
  const [newTab, setNewTab] = useState(false);
  const [second, setSecond] = useState(false);

  const { couponByID } = useSelector((state) => state.Coupon);

  
  useEffect(() => {
    if (couponbaseondomainList.length === 0) {
      dispatch(getCouponsBasedOnDomainAction());
    }
  }, [dispatch]);

  useEffect(() => {
    if (
      match?.params?.couponId !== undefined &&
      couponByID?._id === undefined
    ) {
      dispatch(getCouponByIdAction({ coupon_id: match.params.couponId }));
    }
    if (
      match?.params?.couponId !== undefined &&
      couponByID?._id !== undefined
    ) {
      window.open(
        `/couponsredirect/${match.params.storeName}/${match.params.couponId}`
      );
    }
  }, [match, couponByID, dispatch]);

  useEffect(() => {
    localStorage.setItem("link", link);
    if (redirect) {
      setNewTab(!newTab);
    }
    if (redirect2) {
      setNewTab(!newTab);
    }
  }, [link, newTab, redirect, redirect2, second]);

  useEffect(() => {
    if (link && redirect) {
      setRedirect(false);
      window.open(`/meta-redirect/`, "_blank");
    }
    if (link && redirect2) {
      setRedirect2(false);
      window.open(link, "_blank");
    }
  }, [link, newTab, redirect, redirect2]);

  return (
    <div id="h3-rec" style={{ background: "#f0f0f0" }}>
      <br />
      <Container style={{ borderRadius: "50px" }}>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: "3vh 0",
          }}
        >
          <h1
            style={{
              color: "#2b3cbb",
              "font-size": "30px",
              fontWeight: "bold",
            }}
          >
            Recommended (test)
          </h1>
        </div>
        <br />
        <Row id="rec-h3-row">
          {couponbaseondomainList.slice(0, 16).map((coupon, index) => (
            <Col xl="3" sm="6" style={{ marginBottom: "10px" }}>
              <div style={{ width: "300px" }}>
                <div
                  className="img-container"
                  style={{ width: "300px", height: "240px" }}
                >
                  <div
                    className="img-inner"
                    style={{
                      width: "300px",
                      height: "240px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <div
                      style={{
                        width: "300px",
                        objectFit: "cover",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <img
                        src={getImageUrlhttps(
                          coupon?.image ? coupon?.image : coupon?.store?.image,
                          PlaceHolderImage
                        )}
                        alt=""
                        style={{
                          maxWidth: "100%",
                          maxHeight: "240px",
                          borderRadius: "30px 30px 0 0",
                        }}
                      />
                    </div>
                  </div>
                </div>
                <div className="text-container">
                  <h3 style={{ color: "transparent" }}>A blue bird</h3>
                  <div style={{ color: "#3c4fe0", fontWeight: "500" }}>
                    {coupon?.title?.length > 35
                      ? coupon?.title.substring(0, 35) + "..."
                      : coupon?.title}
                  </div>
                  <br />

                  <button
                    style={{ padding: "11px", marginTop: "5px" }}
                    id="show-code-button-h3"
                    onClick={(e) => {
                      e.stopPropagation();
                      dispatch(
                        getCouponUrlAction(
                          {finalLink: localStorage.getItem("finalLink")}
                        )
                      );

                      if (link) {
                        setSecond(true); //to run useEffect even when link has not changed
                      }

                      if (
                        coupon?.redirection_type ===
                        "zero-redirect-without-refer"
                      ) {
                        setRedirect(true);
                      } else if (
                        coupon?.redirection_type === "zero-redirect-with-refer"
                      ) {
                        setRedirect2(true);
                      } else {
                        localStorage.setItem(
                          "redirection_type",
                          coupon?.redirection_type
                        );

                        window.open(
                          `/couponsredirect/store/store/coupon/store/${coupon?._id}`,
                          "_blank"
                        );
                      }
                    }}
                  >
                    Show code
                  </button>
                </div>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
      <br />
    </div>
  );
}

export default Deals;
